export const AVAILABLE_LANGUAGES = [
  {
    code: 'pt-BR',
    name: 'Português (Brasil)',
    flag: '🇧🇷',
    isDefault: true,
  },
  // Futuros idiomas:
  // {
  //   code: 'en',
  //   name: 'English',
  //   flag: '🇺🇸',
  //   isDefault: false
  // },
  // {
  //   code: 'es',
  //   name: 'Español',
  //   flag: '🇪🇸',
  //   isDefault: false
  // }
];

export const DEFAULT_LANGUAGE = AVAILABLE_LANGUAGES.find((lang) => lang.isDefault)?.code || 'pt-BR';
